import "./ContactUsInfo.css"
import { useTranslation } from "react-i18next";
import locationIcon from "../../../../../assets/icons/location.svg"
import phoneIcon from "../../../../../assets/icons/phone-icon.svg"
import mailIcon from "../../../../../assets/icons/mail-icon.svg"
import whatsappIcon from "../../../../../assets/icons/whatsapp-icon.svg"

function ContactUsInfo() {

  const { t } = useTranslation("contact");

  return (
    <div className="contact-info">
      <h3>{t("contactUsInfo.infoTopic")}</h3>
      <div className="d-flex flex-column gap-3">
        <div className="info-card">
          <picture>
            <img src={locationIcon} alt="" />
          </picture>
          <div>
            <h4>{t("contactUsInfo.officeLabel")}</h4>
            <p className="small">{t("contactUsInfo.officeSubLabel")}</p>
          </div>
        </div>
        <div className="info-card">
          <picture>
            <img src={mailIcon} alt="" />
          </picture>
          <div>
            <h4>{t("contactUsInfo.emailLabel")}</h4>
            <p className="small">info@alnabaatech.com.ly</p>
          </div>
        </div>
        <div className="info-card">
          <picture>
            <img src={mailIcon} alt="" />
          </picture>
          <div>
            <h4>{t("contactUsInfo.emailLabel")}</h4>
            <p className="small">sales@alnabaatech.com.ly</p>
          </div>
        </div>
        <div className="info-card">
          <picture>
            <img src={phoneIcon} alt="" />
          </picture>
          <div>
            <h4>{t("contactUsInfo.phoneLabel")}</h4>
            <p className="small">00218944415799</p>
          </div>
        </div>      
        <div className="info-card">
          <picture>
            <img src={whatsappIcon} alt="" />
          </picture>
          <div>
            <h4>{t("contactUsInfo.whatsappLabel")}</h4>
            <p className="small">00218914451288</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUsInfo;
